<template>
  <v-container fluid v-if="!isMobile">
    <nav>
      <v-app-bar app>
        <v-toolbar-title><v-breadcrumbs :items="items" large></v-breadcrumbs></v-toolbar-title>
      </v-app-bar>
    </nav>

    <v-card-title>Generate Report</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="3">
          <v-subheader>
            <v-select label="Select Report" v-model="select" :items="report" return-object single-line></v-select>
          </v-subheader>
        </v-col>
        <v-col>
          <div>
            <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
              <v-card class="pa-2" slot="input">
                <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                <span style="font-size: 15px;"> {{ formatDate(values2) }}</span>
              </v-card>
            </v-md-date-range-picker>
          </div>
        </v-col>
        <v-col v-if="select == 'Energy(Individual MCB)'">
          <v-progress-circular indeterminate color="primary" v-if="loadingMcb == true"></v-progress-circular>
          <vue-json-to-csv :json-data="energyMcb" :csv-title="titleReport" v-else>
            <p v-if="energyMcb.length == 0" style="color: red" class="pa-2">Please Try Diffence Date</p>
            <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
          </vue-json-to-csv>
        </v-col>
        <v-col v-if="select == 'Energy(3 Phase)'">
          <v-progress-circular indeterminate color="primary" v-if="loadingRyb == true"></v-progress-circular>
          <vue-json-to-csv :json-data="energyRyb" :csv-title="titleReport" v-else>
            <p v-if="energyRyb.length == 0" style="color: red" class="pa-2">Please Try Diffence Date</p>
            <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
          </vue-json-to-csv>
        </v-col>
        <v-col v-if="select == 'Air Quality(CO2)'">
          <v-progress-circular indeterminate color="primary" v-if="loadingAqCo2 == true"></v-progress-circular>
          <vue-json-to-csv :json-data="airQualityCo2" :csv-title="titleReport" v-else>
            <p v-if="airQualityCo2.length == 0" style="color: red" class="pa-2">Please Try Diffence Date</p>
            <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
          </vue-json-to-csv>
        </v-col>
        <v-col v-if="select == 'Temperature & Humidity'">
          <v-progress-circular indeterminate color="primary" v-if="loadingTempHumid == true"></v-progress-circular>
          <vue-json-to-csv :json-data="tempHumid" :csv-title="titleReport" v-else>
            <p v-if="tempHumid.length == 0" style="color: red" class="pa-2">Please Try Diffence Date</p>
            <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
          </vue-json-to-csv>
        </v-col>
        <v-col v-if="select == 'Water Flow Usage'">
          <v-progress-circular indeterminate color="primary" v-if="loadingWaterFlow == true"></v-progress-circular>
          <vue-json-to-csv :json-data="waterFlow" :csv-title="titleReport" v-else>
            <p v-if="waterFlow.length == 0" style="color: red" class="pa-2">Please Try Diffence Date</p>
            <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
          </vue-json-to-csv>
        </v-col>
        <v-col v-if="select == 'Water Tank Level'">
          <v-progress-circular indeterminate color="primary" v-if="loadingWaterLevel == true"></v-progress-circular>
          <vue-json-to-csv :json-data="waterLevel" :csv-title="titleReport" v-else>
            <p v-if="waterLevel.length == 0" style="color: red" class="pa-2">Please Try Diffence Date</p>
            <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
          </vue-json-to-csv>
        </v-col>
      </v-row>
    </v-card>
  </v-container>

  <v-container v-else>
    <nav>
      <v-app-bar app>
        <v-toolbar-title><v-breadcrumbs :items="items" large></v-breadcrumbs></v-toolbar-title>
      </v-app-bar>
    </nav>

    <v-card-title>Generate Report</v-card-title>
    <v-card>
      <v-row>
        <v-col>
          <v-subheader>
            <v-select label="Select Report" v-model="select" :items="report" return-object single-line></v-select>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-container>
            <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
              <v-card class="pa-2" tile slot="input">
                <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                <span style="font-size: 15px;"> {{ formatDate(values2) }}</span>
              </v-card>
            </v-md-date-range-picker>
          </v-container>
        </v-col>
      </v-row>
      <v-row>
        <v-container>
          <v-col v-if="select == 'Energy(Individual MCB)'">
            <v-progress-circular indeterminate color="primary" v-if="loadingMcb == true"></v-progress-circular>
            <vue-json-to-csv :json-data="energyMcb" :csv-title="titleReport" v-else>
              <p v-if="energyMcb.length == 0" style="color: red">Please Try Diffence Date</p>
              <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
            </vue-json-to-csv>
          </v-col>
          <v-col v-if="select == 'Energy(3 Phase)'">
            <v-progress-circular indeterminate color="primary" v-if="loadingRyb == true"></v-progress-circular>
            <vue-json-to-csv :json-data="energyRyb" :csv-title="titleReport" v-else>
              <p v-if="energyRyb.length == 0" style="color: red">Please Try Diffence Date</p>
              <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
            </vue-json-to-csv>
          </v-col>
          <v-col v-if="select == 'Air Quality(CO2)'">
            <v-progress-circular indeterminate color="primary" v-if="loadingAqCo2 == true"></v-progress-circular>
            <vue-json-to-csv :json-data="airQualityCo2" :csv-title="titleReport" v-else>
              <p v-if="airQualityCo2.length == 0" style="color: red">Please Try Diffence Date</p>
              <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
            </vue-json-to-csv>
          </v-col>
          <v-col v-if="select == 'Temperature & Humidity'">
            <v-progress-circular indeterminate color="primary" v-if="loadingTempHumid == true"></v-progress-circular>
            <vue-json-to-csv :json-data="tempHumid" :csv-title="titleReport" v-else>
              <p v-if="tempHumid.length == 0" style="color: red">Please Try Diffence Date</p>
              <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
            </vue-json-to-csv>
          </v-col>
          <v-col v-if="select == 'Water Flow Usage'">
            <v-progress-circular indeterminate color="primary" v-if="loadingWaterFlow == true"></v-progress-circular>
            <vue-json-to-csv :json-data="waterFlow" :csv-title="titleReport" v-else>
              <p v-if="waterFlow.length == 0" style="color: red">Please Try Diffence Date</p>
              <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
            </vue-json-to-csv>
          </v-col>
          <v-col v-if="select == 'Water Tank Level'">
            <v-progress-circular indeterminate color="primary" v-if="loadingWaterLevel == true"></v-progress-circular>
            <vue-json-to-csv :json-data="waterLevel" :csv-title="titleReport" v-else>
              <p v-if="waterLevel.length == 0" style="color: red">Please Try Diffence Date</p>
              <v-btn color="green" v-else> <v-icon>mdi-download</v-icon> Download </v-btn>
            </vue-json-to-csv>
          </v-col>
        </v-container>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueJsonToCsv from "vue-json-to-csv";

  Vue.component("VueJsonToCsv", VueJsonToCsv);

  export default {
    data() {
      return {
        items: [
          {
            text: "Dashboard",
            disabled: false,
            href: "/",
          },
          {
            text: "Settings",
            disabled: true,
            href: "",
          },
          {
            text: "Report",
            disabled: true,
            href: "/report",
          },
        ],
        values1: moment().subtract(24, "hour"),
        values2: moment().endOf("day"),
        presets: [
          {
            label: "Last 1 Hour",
            range: [moment().subtract(1, "hour"), moment().endOf("day")],
          },
          {
            label: "Last 3 Hour",
            range: [moment().subtract(3, "hour"), moment().endOf("day")],
          },
          {
            label: "Last 12 Hour",
            range: [moment().subtract(12, "hour"), moment().endOf("day")],
          },
          {
            label: "Today",
            range: [moment().startOf("day"), moment().endOf("day")],
          },
          {
            label: "This Week",
            range: [moment().subtract(6, "day"), moment().endOf("day")],
          },
          {
            label: "Last Week",
            range: [
              moment()
                .subtract(13, "day")
                .startOf("day"),
              moment()
                .subtract(7, "day")
                .endOf("day"),
            ],
          },
          {
            label: "This Month",
            range: [
              moment()
                .startOf("month")
                .startOf("day"),
              moment().endOf("month"),
            ],
          },
          {
            label: "Last Month",
            range: [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month"),
            ],
          },
        ],
        loadingMcb: true,
        loadingRyb: true,
        loadingAqCo2: true,
        loadingTempHumid: true,
        loadingWaterFlow: true,
        loadingWaterLevel: true,
        select: [],
        report: ["Energy(Individual MCB)", "Energy(3 Phase)", "Air Quality(CO2)", "Temperature & Humidity", "Water Flow Usage", "Water Tank Level"],
        energyMcb: [],
        energyRyb: [],
        airQualityCo2: [],
        tempHumid: [],
        waterFlow: [],
        waterLevel: [],
        isMobile: true,
      };
    },
    mounted() {
      this.loadsEnergyMcb();
      this.loadsEnergyRyb();
      this.loadsAirQualityCo2();
      this.loadsTempHumid();
      this.loadsWaterFlow();
      this.loadsWaterLevel();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    computed: {
      titleReport() {
      var a = this.select;
      switch(a) {
      case 'Energy(Individual MCB)':
      return `Individual_MCB_Report_${moment().format("D_MM_YYYY")}`; 
      case 'Energy(3 Phase)':
      return `3Phase_Report_${moment().format("D_MM_YYYY")}`;
      case 'Air Quality(CO2)':
      return `Air_Quality(CO2)_Report_${moment().format("D_MM_YYYY")}`;
      case 'Temperature & Humidity':
      return `Temperature_Humidity_Report_${moment().format("D_MM_YYYY")}`;
      case 'Water Flow Usage':
      return `Water_Flow_Report_${moment().format("D_MM_YYYY")}`;
      case 'Water Tank Level':
      return `Water_Tank_Level_Report_${moment().format("D_MM_YYYY")}`;
      default:
      return `Report_${moment().format("D_MM_YYYY")}`;
      }
      },
      test() {
        var test = console.log();
        return test;
      },
    },
    methods: {
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsEnergyMcb: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/report/" + this.values1.toDate() + "/" + this.values2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.energyMcb = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingMcb = false));
      },
      loadsEnergyRyb: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/report/" + this.values1.toDate() + "-" + this.values2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.energyRyb = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingRyb = false));
      },
      loadsAirQualityCo2: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/air-quality/co2/report/" + this.values1.toDate() + "-" + this.values2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.airQualityCo2 = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingAqCo2 = false));
      },
      loadsTempHumid: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/temp-humid/report/" + this.values1.toDate() + "/" + this.values2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.tempHumid = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingTempHumid = false));
      },
      loadsWaterFlow: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-flow/report/" + this.values1.toDate() + "/" + this.values2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterFlow = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingWaterFlow = false));
      },
      loadsWaterLevel: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-tank/report/" + this.values1.toDate() + "-" + this.values2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterLevel = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingWaterLevel = false));
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.loadsEnergyMcb();
        this.loadsEnergyRyb();
        this.loadsAirQualityCo2();
        this.loadsTempHumid();
        this.loadsWaterFlow();
        this.loadsWaterLevel();
        this.loadingMcb = true;
        this.loadingRyb = true;
        this.loadingAqCo2 = true;
        this.loadingTempHumid = true;
        this.loadingWaterFlow = true;
        this.loadingWaterLevel = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
  };
</script>
